import { proxy } from 'valtio';
import { ControlPointItem, DataIndexItem, OwnerDetails, OwnerS3, ProjectData } from '../types/interfaces';
import { getS3ForOwner } from '../components/tables/dataIndexTable/DataIndexLambdaUtils';
import AWS from "aws-sdk";
import { getIdToken } from '../components/userManager/userManagementUtils';
import { api_trigger_fxn } from '../utils/APIs/ApiUtils';

interface DataStore {
    dataItems: DataIndexItem[];
    ownerIds: string[];
    ownerDetails: OwnerDetails[];
    owners3Data: OwnerS3[];
    allProjectData: ProjectData[];
    selectedControlPointID: string;
}
const DataStore: DataStore = proxy({
    dataItems: [],
    ownerIds: [],
    ownerDetails: [],
    owners3Data: [],
    allProjectData: [],
    selectedControlPointID: '',
})

//Check dev environment
if (process.env.NODE_ENV === 'development') {
    window.DataStore = DataStore
}

export { DataStore }

export const addDataItemsStore = (items: DataIndexItem[]) => {
    const dataItems = DataStore.dataItems
    items.forEach((item) => {
        const index = dataItems.findIndex((data) => data.data_id === item.data_id);
        if (index === -1) {
            dataItems.push(item);
        } else {
            dataItems[index] = item;
        }
    })
}

export const addDataItemStore = (item: DataIndexItem) => {
    const dataItems = DataStore.dataItems
    const index = dataItems.findIndex((data) => data.data_id === item.data_id);
    if (index === -1) {
        dataItems.push(item);
    } else {
        dataItems[index] = item;
    }
}

export const getDataItemStore = (dataId: string, snap: any) => {
    const dataItems = snap ? snap.dataItems : DataStore.dataItems
    return dataItems.find((item: DataIndexItem) => item.data_id === dataId);
}

export const addOwnerIdsStore = (ids: string[]) => {
    const ownerIds = DataStore.ownerIds
    const newIds = ids.filter((id) => !ownerIds.includes(id));
    DataStore.ownerIds = ownerIds.concat(newIds);
}

export const addOwnerDetailsStore = (details: OwnerDetails[]) => {
    const ownerDetails = DataStore.ownerDetails
    const newDetails = details.filter((detail) => !ownerDetails.some((owner) => owner.owner_id === detail.owner_id));
    DataStore.ownerDetails = ownerDetails.concat(newDetails);
}

export const changeDataItemStore = (dataId: string, newData: any) => {
    const dataItems = DataStore.dataItems
    const item = dataItems.find((data) => data.data_id === dataId);
    if (item) {
        const indexNumber = dataItems.indexOf(item);
        dataItems[indexNumber] = { ...item, ...newData };
    }
}

export const getDataItemFromDataId = (dataId: string) => {
    return DataStore.dataItems.find((item) => item.data_id === dataId);
}

export const getDataItemsFromEntwinePathStore = (entwinePath: string) => {
    return DataStore.dataItems.filter((item) => item.entwine_build_path === entwinePath);
}

function addOwnerS3(ownerS3: OwnerS3) {
    DataStore.owners3Data.push(ownerS3);
}

export const getOwnerS3Store = async (ownerId: string): Promise<AWS.S3 | null> => {
    const owners3Data = DataStore.owners3Data
    return new Promise(async (resolve, reject) => {
        let ownerS3 = owners3Data.find((owner) => owner.owner_id === ownerId);
        if (ownerS3) {
            resolve(ownerS3.s3_bucket);
            return;
        }
        let data;
        try {
            data = await getS3ForOwner(ownerId);
        } catch (err) {
            resolve(null);
        }
        const parsed_resp = JSON.parse(data)
        const credentials = new AWS.Credentials(
            parsed_resp.AccessKeyId,
            parsed_resp.SecretAccessKey,
            parsed_resp.SessionToken);
        const scoped_s3 = new AWS.S3({
            region: AWS.config.region,
            credentials: credentials
        });
        addOwnerS3({ owner_id: ownerId, s3_bucket: scoped_s3 });
        resolve(scoped_s3);
    })
}

export const updateItemStore = (dataId: string, newData: any) => {
    const dataIndexItems = DataStore.dataItems
    const item = dataIndexItems.find((data) => data.data_id === dataId);
    if (item) {
        const indexNumber = dataIndexItems.indexOf(item);
        dataIndexItems[indexNumber] = { ...item, ...newData };
        return true;
    }
    return false;
}

export const updateDataItemOnServerStore = async (values: any, callBack: ((body: any) => void) | undefined) => {
    let idToken;
    try {
        idToken = await getIdToken();
    } catch (err) {
        return
    }
    const params = {
        action: "update",
        data_id: values.data_id,
        owner_id: values.owner_id,
        update_dict: values,
    };
    let body: { message: string };
    try {
        body = await api_trigger_fxn("data_index", params);
        if (body && callBack) {
            callBack(body);
        }
    } catch (err) {
        console.error("Error triggering API function:", err);
        return
    }
}

export const addTiePointStore = (project: string, pointIndex: string, tiePointItem: ControlPointItem) => {
    const allProjectData = DataStore.allProjectData
    const projectItem = allProjectData.find((p) => p.project === project);
    if (projectItem) {
        const pointItem = projectItem.data.find((p) => p.no === pointIndex);
        if (pointItem) {
            pointItem.tiePoint = tiePointItem;
        }
    }

    return true;
}

export const removeTiePointStore = (project: string, pointIndex: string) => {
    const allProjectData = DataStore.allProjectData
    const projectItem = allProjectData.find((p) => p.project === project);
    if (projectItem) {
        const pointItem = projectItem.data.find((p) => p.no === pointIndex);
        if (pointItem) {
            pointItem.tiePoint = undefined;
        }
    }

    return true;
}

export const removeDataItemStore = (dataId: string) => {
    const dataItems = DataStore.dataItems
    const index = dataItems.findIndex((data) => data.data_id === dataId);
    if (index > -1) {
        dataItems.splice(index, 1);
    }
}